export default function formatSortFields({ field, sort }) {
  return {
    sorting: {
      sort: field,
      direction:
        sort.sort === field && sort.direction === 'asc' ? 'desc' : 'asc',
    },
  };
}
